// Tracks whether the player has ever finished a match. Used to hold back
// engagement nudges (e.g. the install prompt) until someone has actually
// played, rather than pestering a first-time visitor on the home screen.
// Persisted, so a returning player who already played counts immediately.

const KEY = "ar_played_match";

function readInitial(): boolean {
  if (typeof window === "undefined") return false;
  try {
    return window.localStorage.getItem(KEY) === "1";
  } catch {
    return false;
  }
}

let finished = readInitial();
const listeners = new Set<() => void>();

// Call when a match reaches its end (see App.goToFlow -> "match-over").
export function markMatchFinished(): void {
  if (finished) return;
  finished = true;
  try {
    window.localStorage.setItem(KEY, "1");
  } catch {
    /* storage blocked (private mode); in-memory flag still works this session */
  }
  listeners.forEach((l) => l());
}

export function hasFinishedMatch(): boolean {
  return finished;
}

export function subscribePlayed(fn: () => void): () => void {
  listeners.add(fn);
  return () => {
    listeners.delete(fn);
  };
}
